import { createContext } from 'react'

import type { ConfigurationStepContextValue } from './configuration-step-context.interface'

export const ConfigurationStepContext = createContext<ConfigurationStepContextValue>({
  step: 0,
  handleNext: () => {},
})
